import { Cobrander } from 'app/model/cobrander';

import { RestfulApiService } from './restful-api.service';

class CobranderService extends RestfulApiService<Cobrander> {
    protected getFormName(): string {
        return 'cobrander';
    }

    protected getPath(): string {
        return 'cobranders';
    }
}

export const cobranderService = new CobranderService();
